import styled from '@emotion/styled';
import { tokens, Avatar } from '@hotjar/hotsauce';
import { MoreButton } from '@hotjar/webapp/components/MoreButton';

const AvatarListItem = styled.li`
  display: flex;
  list-style-type: none;
  margin-left: -${tokens.spacer.x1};

  :first-of-type {
    margin-left: 0;
  }
`;

const AvatarList = styled.ul`
  display: flex;
  flex-direction: row;
  padding: 0;
  margin: 0;
`;

const Container = styled.div<{ isClickable: boolean }>`
    display: flex;
    justify-content: center;
    ${(p) => (p.isClickable ? 'pointer' : 'default')};
  }
`;

const StyledMoreButton = styled(MoreButton)`
  margin-left: -${tokens.spacer.x1};
  margin-right: ${tokens.spacer.x1};
`;

function createMoreCommentersTooltip(users: Array<{ name: string }>, usersToSummarise: number) {
  return users
    .slice(users.length - usersToSummarise)
    .map((user) => user.name)
    .join('\n');
}

export interface CommentersProps {
  users: Array<{
    avatar: string | null;
    id: number;
    name: string;
  }>;
  limit?: number;
  onClick?: () => void;
}

export function Commenters({ users, onClick, limit = 2 }: CommentersProps): JSX.Element {
  const usersToShow = Math.min(users.length > limit ? limit - 1 : limit, users.length);
  const usersToSummarise = users.length - usersToShow;
  return (
    <Container onClick={onClick} isClickable={onClick !== undefined}>
      <AvatarList>
        {users.slice(0, usersToShow).map((user) => (
          <AvatarListItem key={user.id}>
            <Avatar size="l" src={user.avatar ?? undefined} userName={user.name} />
          </AvatarListItem>
        ))}
      </AvatarList>
      {usersToSummarise > 0 && (
        <StyledMoreButton
          size={24}
          number={usersToSummarise}
          tooltipText={createMoreCommentersTooltip(users, usersToSummarise)}
          outline
          cursor={onClick ? 'pointer' : 'default'}
        />
      )}
    </Container>
  );
}
